import {Box, Text, Button, Center, Flex, Image} from '@chakra-ui/react';
import {useState} from 'react';
import {useRouter} from 'next/router';
import {useAppToast} from '../hooks/app-toast';
import {PageLayout} from '../components/global/page-layout';
import {
  useUserQuery,
  useUpdateUserDisplayedSideAssetMutation,
} from '../graphql/generated';
import {Routes, VALENTINES_DAY_MASCARA} from '../shared/consts';

export const IMAGES = [
  {
    imageSrc: '/assets/banksy/housewife.jpg',
    id: 1,
  },
  {
    imageSrc: '/assets/banksy/shoes.jpg',
    id: 2,
  },
  {
    imageSrc: '/assets/banksy/wink.jpg',
    id: 3,
  },
  {
    imageSrc: '/assets/banksy/banksy-side.jpg',
    id: 4,
  },
];

const ChooseMyImage: React.FC = () => {
  const userQuery = useUserQuery();
  const toast = useAppToast();
  const router = useRouter();

  const [activeImage, setActiveImage] = useState<number>(0);

  const [updateUserDisplayedSideAsset, {loading}] =
    useUpdateUserDisplayedSideAssetMutation();

  const handleCertificate = () => {
    updateUserDisplayedSideAsset({
      variables: {
        assetId: VALENTINES_DAY_MASCARA,
        side: activeImage,
      },
    })
      .then(() => {
        router.push(
          `${Routes.MY_COLLECTION}?certificate=1&piece=${VALENTINES_DAY_MASCARA}`,
        );
      })
      .catch((error) => {
        toast.showErrorToast(error);
      });
  };
  return (
    <PageLayout firstName={userQuery.data?.user?.firstName}>
      <Box
        textAlign="center"
        mb="64px"
        mt={{base: '0px', lg: '60px'}}
        px={{base: '37px', md: '170px', lg: '300px'}}
      >
        <Text as="h2" textStyle={{base: 'h6', lg: 'h4'}}>
          How do you want the artwork to show in your collection? Select one.
        </Text>
      </Box>
      <Flex
        alignItems="center"
        justifyContent="center"
        flexWrap={{base: 'wrap', md: 'nowrap'}}
        maxWidth={{base: '400px', md: '768px'}}
        margin="0 auto"
      >
        {IMAGES.map((img: any) => (
          <Box
            px={{base: '8px', lg: '11px'}}
            key={img.imageSrc}
            width={{base: '50%', md: '100%'}}
          >
            <Box
              alignItems="center"
              justifyContent="center"
              cursor="pointer"
              border="5px solid white"
              borderColor={activeImage === img.id ? 'aqua.500' : 'white'}
              borderRadius="8px"
              as="button"
              onClick={() => setActiveImage(img.id)}
            >
              <Image src={img.imageSrc} borderRadius="8px" alt="portrait" />
            </Box>
          </Box>
        ))}
      </Flex>
      <Center mt={{base: '40px', lg: '100px'}}>
        <Button
          colorScheme="aqua"
          size="lg"
          w={{base: 'medium', lg: 'full'}}
          maxW="400px"
          onClick={handleCertificate}
          disabled={loading}
        >
          Continue to view my certificate
        </Button>
      </Center>
    </PageLayout>
  );
};

export default ChooseMyImage;
